export default __webpack_public_path__ + "static/media/bills_import_template.325ec4ef.csv";